import React, {Component} from 'react';
import {connect} from 'react-redux';
import InnerHeader from '../../components/InnerHeader/InnerHeader';
import { setUserLogout, getMe } from '../../store/actions/userActions';

class InnerPage extends Component {

  componentDidMount() {
    this.props.getMe();
  }

  onLogout = () => {
    localStorage.removeItem("openedTool");
    this.props.setUserLogout();
  }

  render() {
    return (
      <div id="page-wrapper">
        <div className="app-body">
          <InnerHeader
            isLoggedIn={this.props.isLoggedIn}
            onLogout={this.onLogout}
            changeUserPassword={this.props.changeUserPassword}
            changePasswordResult={this.props.changePasswordResult}
            location={this.props.location}
            me={this.props.me}
          />
          <div className="app-content">
              {this.props.children}
          </div>
        </div>
      </div>
    )
  }
}

function MapStateToProps(state, ownProps) {
  return {
    me: state.user.me
  }
}
const mapDispatchToProps = (dispatch) => ({
  getMe: () => dispatch(getMe()),
  setUserLogout: () => dispatch(setUserLogout()),
});
//export default InnerPage;
export default connect(MapStateToProps, mapDispatchToProps)(InnerPage);



// WEBPACK FOOTER //
// ./src/shared/InnerPage/InnerPage.jsx